"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoPlayerControls = void 0;

var _react = _interopRequireWildcard(require("react"));

var _atoms = require("../../atoms");

var _molecules = require("../../molecules");

var _VideoSlider = require("../../molecules/VideoSlider");

var _helpers = require("../../util/helpers");

var _enterFullScreen = require("./enterFullScreen");

var _exitFullScreen = require("./exitFullScreen");

var _usePlaylistControls2 = require("./usePlaylistControls");

var _useVideoControls2 = require("./useVideoControls");

var _useVideoInfo2 = require("./useVideoInfo");

var _excluded = ["containerRef", "fullGameTime", "title", "extraVideoControls", "extraUserControls", "onOpenVideoSettingsDialog", "children", "toaster", "camerasCount", "noMulticam", "multicamTooltipOpen", "onMulticamTooltipClose", "fullScreenElementSelector", "disabledControls", "controlsForcedOpen"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var VideoPlayerControls = function VideoPlayerControls(_ref) {
  var containerRef = _ref.containerRef,
      fullGameTime = _ref.fullGameTime,
      title = _ref.title,
      extraVideoControls = _ref.extraVideoControls,
      extraUserControls = _ref.extraUserControls,
      onOpenVideoSettingsDialog = _ref.onOpenVideoSettingsDialog,
      children = _ref.children,
      toaster = _ref.toaster,
      camerasCount = _ref.camerasCount,
      noMulticam = _ref.noMulticam,
      multicamTooltipOpen = _ref.multicamTooltipOpen,
      onMulticamTooltipClose = _ref.onMulticamTooltipClose,
      fullScreenElementSelector = _ref.fullScreenElementSelector,
      disabledControls = _ref.disabledControls,
      controlsForcedOpen = _ref.controlsForcedOpen,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      fullscreen = _useState2[0],
      setFullscreen = _useState2[1];

  var hideControls = disabledControls ? disabledControls : [];
  var forceControlsOpen = controlsForcedOpen ? controlsForcedOpen : false;
  var isSmallMobile = (0, _helpers.isSmallMobileScreen)();

  var _useVideoInfo = (0, _useVideoInfo2.useVideoInfo)(containerRef),
      paused = _useVideoInfo.paused,
      duration = _useVideoInfo.duration,
      currentTime = _useVideoInfo.currentTime,
      multicamOpen = _useVideoInfo.multicamOpen;

  var _usePlaylistControls = (0, _usePlaylistControls2.usePlaylistControls)(containerRef),
      goToNext = _usePlaylistControls.goToNext;

  var _useVideoControls = (0, _useVideoControls2.useVideoControls)(containerRef),
      play = _useVideoControls.play,
      pause = _useVideoControls.pause,
      jump = _useVideoControls.jump,
      jumpForward = _useVideoControls.jumpForward,
      jumpBack = _useVideoControls.jumpBack,
      toggleMulticam = _useVideoControls.toggleMulticam;

  var handleToggleMulticam = function handleToggleMulticam(e) {
    if (camerasCount > 1) {
      toggleMulticam(e);
    } else {
      toaster("Not filmed in MultiCam");
    }
  };

  var toggleFullscreen = function toggleFullscreen() {
    if (fullscreen) {
      (0, _exitFullScreen.exitFullScreen)(setFullscreen);
    } else {
      var selector = "#root";

      if (fullScreenElementSelector) {
        selector = fullScreenElementSelector;
      }

      (0, _enterFullScreen.enterFullScreen)(selector, setFullscreen);
    }
  };

  var fullScreenListener = function fullScreenListener(e) {
    if (document.webkitFullscreenElement || document.fullscreenElement) {
      setFullscreen(true);
    } else {
      setFullscreen(false);
    }
  };

  var fullscreenEnded = function fullscreenEnded(e) {
    setFullscreen(false);
  };

  var handleOnMulticamTooltipClose = function handleOnMulticamTooltipClose(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    if (typeof onMulticamTooltipClose === "function") {
      onMulticamTooltipClose();
    }
  };

  var handleOnMouseOver = function handleOnMouseOver(e) {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
  };

  (0, _react.useEffect)(function () {
    document.addEventListener("fullscreenchange", fullScreenListener);
    document.addEventListener("webkitfullscreenchange", fullScreenListener);
    document.addEventListener("mozfullscreenchange", fullScreenListener);
    document.addEventListener("MSFullscreenChange", fullScreenListener);
    var video = document.querySelector('.VideoPlayer video.main-video[data-active="true"]');

    if (video) {
      video.addEventListener("webkitendfullscreen", fullscreenEnded);
    }

    return function () {
      document.removeEventListener("fullscreenchange", fullScreenListener);
      document.removeEventListener("webkitfullscreenchange", fullScreenListener);
      document.removeEventListener("mozfullscreenchange", fullScreenListener);
      document.removeEventListener("MSFullscreenChange", fullScreenListener);

      if (video) {
        video.removeEventListener("webkitendfullscreen", fullscreenEnded);
      }
    };
  }, [fullScreenListener]);
  var fgt = fullGameTime ? fullGameTime : 0;
  var controlsCn = forceControlsOpen ? "VideoPlayerControls force-open" : "VideoPlayerControls";
  return /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    trkContext: "Video Controls",
    className: controlsCn
  }, children, /*#__PURE__*/_react.default.createElement(_VideoSlider.VideoSlider, {
    play: play,
    pause: pause,
    jump: jump,
    fullGameTime: fgt,
    currentTime: currentTime,
    duration: duration
  }), /*#__PURE__*/_react.default.createElement(_atoms.Row, null, /*#__PURE__*/_react.default.createElement(_molecules.VideoControls, null, paused && /*#__PURE__*/_react.default.createElement(_molecules.VideoControlButton, {
    trkAction: "Play Pressed",
    onClick: function onClick(e) {
      if (toaster) {
        toaster("Play");
      }

      play();
    },
    icon: _atoms.Icon.Type.Play,
    iconSize: "24",
    margin: "4",
    title: "Play"
  }), !paused && /*#__PURE__*/_react.default.createElement(_molecules.VideoControlButton, {
    trkAction: "Pause Pressed",
    onClick: function onClick(e) {
      if (toaster) {
        toaster("Pause");
      }

      pause();
    },
    icon: _atoms.Icon.Type.Pause,
    iconSize: "24",
    title: "Pause"
  }), /*#__PURE__*/_react.default.createElement(_molecules.VideoControlButton, {
    trkAction: "Jump Back Pressed",
    onClick: function onClick(e) {
      if (toaster) {
        toaster("-5");
      }

      jumpBack(5);
    },
    icon: _atoms.Icon.Type.JumpBack5,
    iconSize: "24",
    title: "-5 sec"
  }), /*#__PURE__*/_react.default.createElement(_molecules.VideoControlButton, {
    trkAction: "Jump Forward Pressed",
    onClick: function onClick(e) {
      if (toaster) {
        toaster("+5");
      }

      jumpForward(5);
    },
    icon: _atoms.Icon.Type.JumpAhead5,
    iconSize: "24",
    title: "+5 sec"
  }), !hideControls.includes("next") && /*#__PURE__*/_react.default.createElement(_molecules.VideoControlButton, {
    trkAction: "Next Pressed",
    onClick: function onClick(e) {
      if (toaster) {
        toaster("Next");
      }

      goToNext();
    },
    icon: _atoms.Icon.Type.Next,
    iconSize: "24",
    title: "Next moment"
  }), /*#__PURE__*/_react.default.createElement(_molecules.VideoControlButton, {
    className: "FullScreenButton",
    trkAction: "Full Screen Pressed",
    onClick: function onClick(e) {
      if (toaster) {
        if (fullscreen) {
          toaster("Exit Full Screen");
        } else {
          toaster("Enter Full Screen");
        }
      }

      toggleFullscreen();
    },
    icon: fullscreen ? _atoms.Icon.Type.Collapse : _atoms.Icon.Type.Expand,
    iconSize: isSmallMobile ? "16" : "24",
    title: "Full screen"
  }), /*#__PURE__*/_react.default.createElement(_molecules.VideoControlButton, {
    className: "SettingsButton",
    trkAction: "Settings Pressed",
    onClick: function onClick(e) {
      return onOpenVideoSettingsDialog(true);
    },
    icon: _atoms.Icon.Type.Settings,
    iconSize: isSmallMobile ? "16" : "24",
    title: "Settings"
  }), !noMulticam && /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    onMouseOver: function onMouseOver(e) {
      return handleOnMouseOver(e);
    },
    className: "VideoControlButtonContainer multicam-button-container"
  }, /*#__PURE__*/_react.default.createElement(_molecules.VideoControlButton, {
    trkAction: "Toggle Multicam Pressed",
    onClick: function onClick(e) {
      return handleToggleMulticam(e);
    },
    icon: _atoms.Icon.Type.Multicam,
    iconColor: multicamOpen ? _atoms.Color.Warning : _atoms.Color.White2,
    iconSize: "24",
    title: "MultiCam"
  }), /*#__PURE__*/_react.default.createElement(_molecules.MulticamTooltip, {
    hideAfter: null,
    open: multicamTooltipOpen,
    onClose: handleOnMulticamTooltipClose
  })), extraVideoControls), /*#__PURE__*/_react.default.createElement(_molecules.VideoControls, {
    className: "UserControls"
  }, extraUserControls)));
};

exports.VideoPlayerControls = VideoPlayerControls;